import { render } from "./ServiceSection.vue?vue&type=template&id=180b031a"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ynyan\\Desktop\\官网\\YNOfficialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__